const loadLocalUserStorage = () => ({ type: 'LOAD_LOCAL_USER_STORAGE' });

export default loadLocalUserStorage;
